import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Last from "./Last";

const BuyPage = () => {
  const { category } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [filteredImages, setFilteredImages] = useState([]);

  // Get ?sub= from URL
  const searchParams = new URLSearchParams(location.search);
  const initialSubcategory = searchParams.get("sub");

  const formattedCategory = category
    ?.split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  useEffect(() => {
    fetch("https://prsilks.com/proxy.php")
      .then((res) => res.json())
      .then((data) => {
        const categoryData = data.filter(
          (item) =>
            item.category?.toLowerCase() ===
            formattedCategory?.toLowerCase()
        );
        const uniqueSubs = [
          ...new Set(
            categoryData.map((item) => item.subcategory).filter(Boolean)
          ),
        ];
        setSubcategories(uniqueSubs);

        // If ?sub= is available in URL, use that
        const defaultSub = initialSubcategory || uniqueSubs[0];

        if (defaultSub) {
          setSelectedSubcategory(defaultSub);
          const defaultImages = categoryData.filter(
            (item) => item.subcategory === defaultSub
          );
          setFilteredImages(defaultImages);
        } else {
          setFilteredImages(categoryData);
        }
      });
  }, [formattedCategory, initialSubcategory]);

  useEffect(() => {
    if (!selectedSubcategory) return;

    fetch("https://prsilks.com/proxy.php")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (item) =>
            item.category?.toLowerCase() ===
              formattedCategory?.toLowerCase() &&
            item.subcategory === selectedSubcategory
        );
        setFilteredImages(filtered);
      });
  }, [selectedSubcategory, formattedCategory]);

  return (
    <div className="bg-[#ECE5DC]">
      
      <div className="p-6 mt-20 2xl:mt-20 8xl:mt-28 10xl:mt-44 11xl:mt-56">
        <button
  onClick={() => navigate(-1)}
  className="w-8 h-8 flex items-center justify-center border-2 border-secondary text-secondary rounded-full hover:bg-secondary hover:text-primary transition"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    className="w-5 h-5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 19l-7-7 7-7"
    />
  </svg>
</button>

        <div className="sm:flex mt-4 gap-3 justify-between items-center">
          {/* Back Button + Title */}
          
          <div className="flex items-center gap-3 mb-4">
           
            <h1 className="text-2xl 4xl:text-3xl 6xl:text-4xl 9xl:text-6xl text-secondary font-abhaya font-bold tracking-[4px]">
              {formattedCategory}
            </h1>
          </div>

          {/* Subcategory Dropdown */}
          {subcategories.length > 0 && (
            <div className="mb-4 flex justify-end">
              <select
                className="p-2 border-2 9xl:border-3 border-secondary bg-[#ECE5DC] text-secondary rounded md:text-lg 7xl:text-xl 9xl:text-4xl"
                value={selectedSubcategory}
                onChange={(e) => setSelectedSubcategory(e.target.value)}
              >
                {subcategories.map((sub, index) => (
                  <option className="text-lg" key={index} value={sub}>
                    {sub}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* Saree Cards */}
        {filteredImages.length > 0 ? (
          <div className="grid grid-cols-2 3xl:grid-cols-4 gap-4 8xl:gap-7">
            {filteredImages.map((item, index) => (
              <div
                className="rounded shadow-lg bg-white 8xl:rounded-lg 10xl:rounded-xl 11xl:rounded-2xl"
                key={index}
              >
                <img
                  src={item.url}
                  alt={`saree-${index}`}
                  className="p-1 lg:p-3 rounded-md md:rounded-lg xl:rounded-2xl 11xl:rounded-3xl w-full object-cover"
                  loading="lazy"
                />
                <div className="flex py-2 px-2 justify-between items-center font-bold">
                  <p className="font-sans">{item.price}</p>
                  <a
                    href={`https://api.whatsapp.com/send?phone=919363799534&text=${encodeURIComponent(
                      `I am interested to buy your ${item.name} ${item.url} ${item.price}`
                    )}`}
                    className="border border-secondary bg-secondary rounded-full px-1 text-primary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Buy now
                  </a>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center font-sans font-semibold text-lg 4xl:text-xl 6xl:text-2xl text-secondary">
            "Loading beautiful sarees... Just a moment!"
          </p>
        )}
      </div>
      <Last />
    </div>
  );
};

export default BuyPage;
